import { useInfiniteQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { getLeaderBoard } from '@/api/loans';
import { GET_LEADERBOARD } from '@/utils/queryKey';

export const useLeaderboard = () => {
  const { query } = useRouter();
  const sort = query.sort as string;
  const dir = query.dir as string;

  return useInfiniteQuery({
    queryKey: [GET_LEADERBOARD, sort, dir],
    queryFn: ({ pageParam = 1 }) => {
      return getLeaderBoard({ page: pageParam, limit: 10, sort, dir });
    },
    getNextPageParam: (lastPage, pages) => {
      return lastPage.count > pages.reduce((acc, curr) => acc + curr.rows.length, 0) ? pages.length + 1 : undefined;
    },
    initialPageParam: 1,
  });
};
